import { useDeleteUnitMutation, useGetUnitsQuery } from "../../store/data/unitsSlice";
import { IonButton, IonFab, IonFabButton, IonIcon, IonItem, IonLabel, IonList } from "@ionic/react";
import { add, pencilOutline, trashOutline } from "ionicons/icons";
import { Link } from "react-router-dom";
import { DataLoadingWardenForQuery } from "../../components/DataLoadingWardenForQuery";
import { ActionWithConfirmation } from "../../components/ActionWithConfirmation";
import { RedirectActionButton } from "../../components/previews/RedirectActionButton";

class ContainerProps {}

export const UnitList: React.FC<ContainerProps> = () => {
    const units = useGetUnitsQuery("empty for now");
    const [remove, result] = useDeleteUnitMutation();

    return (
        <DataLoadingWardenForQuery query={units}>
            {() => (
                <>
                    <IonList className="menu-list-component">
                        {units.data.result.map((x) => (
                            <IonItem key={x.id}>
                                <IonLabel>{x.name}</IonLabel>
                                <RedirectActionButton
                                    text="Edytuj"
                                    to={`/dictionaries/units/update/${x.id}`}
                                    icon={pencilOutline}
                                />
                                <ActionWithConfirmation
                                    message={`Czy na pewno chcesz usunąć jednostkę ${x.name}?`}
                                    header="Usuwanie jednostki"
                                    confirmedAction={() => remove({ id: x.id })}
                                />
                            </IonItem>
                        ))}
                    </IonList>
                    <IonFab
                        slot="fixed"
                        vertical="bottom"
                        horizontal="end"
                    >
                        <Link to="/dictionaries/units/add">
                            <IonFabButton>
                                <IonIcon icon={add}></IonIcon>
                            </IonFabButton>
                        </Link>
                    </IonFab>
                </>
            )}
        </DataLoadingWardenForQuery>
    );
};
